export type DeToolCategory =
  | "Zufall & Auswahl"
  | "Glücksräder"
  | "Teams & Gruppen"
  | "Unterricht & Schule"
  | "Spiele & Spaß";

export interface DeToolMeta {
  slug: string;
  enSlug: string;
  name: string;
  tagline: string;
  category: DeToolCategory;
  icon: string;
  featured?: boolean;
  keywords: string[];
}

export const DE_CATEGORIES: DeToolCategory[] = [
  "Zufall & Auswahl",
  "Glücksräder",
  "Teams & Gruppen",
  "Unterricht & Schule",
  "Spiele & Spaß",
];

export const DE_TOOLS: DeToolMeta[] = [
  {
    slug: "zufalls-namensgenerator",
    enSlug: "random-name-picker",
    name: "Zufalls-Namensgenerator",
    tagline: "Wähle Schüler oder Namen schnell und fair mit Animation aus.",
    category: "Zufall & Auswahl",
    icon: "Shuffle",
    featured: true,
    keywords: ["zufalls namensgenerator", "namen ziehen zufall", "zufälliger namensauswähler", "namensgenerator schule"],
  },
  {
    slug: "schueler-zufallsgenerator",
    enSlug: "random-student-picker",
    name: "Schüler-Zufallsgenerator",
    tagline: "Klassenliste eingeben und fairen Schüler per Zufall auswählen.",
    category: "Zufall & Auswahl",
    icon: "GraduationCap",
    featured: true,
    keywords: ["schüler zufallsgenerator", "schüler auswählen zufall", "unterricht zufallsgenerator", "klassenliste ziehen"],
  },
  {
    slug: "gluecksrad-online",
    enSlug: "spin-the-wheel",
    name: "Glücksrad Online Drehen",
    tagline: "Buntes Online-Entscheidungsrad für Namen, Aufgaben und Entscheidungen.",
    category: "Glücksräder",
    icon: "Disc3",
    featured: true,
    keywords: ["glücksrad online", "glücksrad drehen", "online rad drehen", "entscheidungsrad"],
  },
  {
    slug: "namensrad",
    enSlug: "wheel-of-names",
    name: "Namensrad Online",
    tagline: "Namen eingeben und das Glücksrad drehen, um einen Gewinner zu ziehen.",
    category: "Glücksräder",
    icon: "Disc3",
    featured: true,
    keywords: ["namensrad", "glücksrad namen", "namen rad drehen", "zufallsrad namen"],
  },
  {
    slug: "ja-nein-rad",
    enSlug: "yes-or-no-wheel",
    name: "Ja-Nein-Rad",
    tagline: "Schnelle 50/50 Entscheidungshilfe per Online-Glücksrad.",
    category: "Glücksräder",
    icon: "HelpCircle",
    featured: true,
    keywords: ["ja nein rad", "ja oder nein rad", "ja nein generator", "entscheidung ja nein"],
  },
  {
    slug: "gewinnspiel-rad",
    enSlug: "prize-wheel",
    name: "Gewinnspiel & Belohnungs-Rad",
    tagline: "Drehe das Rad für Preise, Belohnungen und Schul-Incentives.",
    category: "Glücksräder",
    icon: "Gift",
    featured: true,
    keywords: ["gewinnspiel rad", "belohnungsrad", "tombola rad online", "preise ziehen rad"],
  },
  {
    slug: "zahlen-rad",
    enSlug: "number-wheel",
    name: "Zahlen-Glücksrad",
    tagline: "Drehe ein Rad mit Zahlen von 1 bis 100 oder eigenen Bereichen.",
    category: "Glücksräder",
    icon: "Hash",
    keywords: ["zahlen rad", "zahlen zufallsgenerator rad", "online zahlenrad"],
  },
  {
    slug: "essen-entscheidungsrad",
    enSlug: "food-wheel",
    name: "Was soll ich essen? Glücksrad",
    tagline: "Unentschlossen beim Essen? Drehe das Entscheidungsrad für Mahlzeiten!",
    category: "Glücksräder",
    icon: "Utensils",
    keywords: ["was soll ich essen rad", "essen zufallsgenerator", "mittagessen rad", "essen entscheiden"],
  },
  {
    slug: "team-generator",
    enSlug: "team-generator",
    name: "Team-Generator (Zufallsteams)",
    tagline: "Teile jede Klasse oder Gruppe mit einem Klick in faire Teams ein.",
    category: "Teams & Gruppen",
    icon: "Users",
    featured: true,
    keywords: ["team generator zufall", "teams erstellen online", "gruppen einteilen zufall", "faire teams bilden"],
  },
  {
    slug: "gruppen-generator",
    enSlug: "group-maker",
    name: "Gruppen-Generator",
    tagline: "Erstelle zufällige Gruppen nach Gruppenanzahl oder Gruppengröße.",
    category: "Teams & Gruppen",
    icon: "UsersRound",
    keywords: ["gruppen generator", "zufällige gruppen erstellen", "gruppen bilden online"],
  },
  {
    slug: "partner-generator",
    enSlug: "partner-generator",
    name: "Partner-Generator (Paare)",
    tagline: "Erstelle sofort zufällige Partnerarbeiten, inkl. 3er-Team bei ungerader Zahl.",
    category: "Teams & Gruppen",
    icon: "Handshake",
    keywords: ["partner generator", "partnerarbeit zufall", "paare bilden online"],
  },
  {
    slug: "zufallszahlen-generator",
    enSlug: "random-number-generator",
    name: "Zufallszahlen-Generator",
    tagline: "Generiere Zahlen in jedem beliebigen Bereich, eindeutig oder wiederholend.",
    category: "Zufall & Auswahl",
    icon: "Hash",
    keywords: ["zufallszahlen generator", "zufallszahl ziehen", "zahlen zufall online"],
  },
  {
    slug: "wuerfel-online",
    enSlug: "dice-roller",
    name: "Virtueller Würfel Online",
    tagline: "Würfele W4 bis W100 mit realistischer Würfelanimation.",
    category: "Spiele & Spaß",
    icon: "Dices",
    keywords: ["würfel online", "virtueller würfel", "online würfeln"],
  },
  {
    slug: "muenze-werfen",
    enSlug: "coin-flip",
    name: "Münze werfen Online (Kopf oder Zahl)",
    tagline: "Kopf oder Zahl in Sekunden entschieden mit 3D-Münzwurf.",
    category: "Spiele & Spaß",
    icon: "CircleDollarSign",
    keywords: ["münze werfen online", "kopf oder zahl online", "münzwurf online"],
  },
  {
    slug: "schul-timer",
    enSlug: "classroom-timer",
    name: "Schul- & Klassenzimmer-Timer",
    tagline: "Großer projektorgeeigneter Countdown-Timer mit Schnellstart-Vorgaben.",
    category: "Unterricht & Schule",
    icon: "Timer",
    featured: true,
    keywords: ["schul timer", "klassenzimmer countdown", "unterricht timer online", "countdown für lehrer"],
  },
  {
    slug: "sitzplan-generator",
    enSlug: "seating-chart",
    name: "Klassenzimmer-Sitzplan-Generator",
    tagline: "Verteile Schüler zufällig auf Reihen, Paare oder Gruppentische – druckbereit.",
    category: "Unterricht & Schule",
    icon: "LayoutGrid",
    keywords: ["sitzplan generator", "sitzplan schule zufall", "klassen sitzplan erstellen"],
  },
  {
    slug: "klassendienste-auswahl",
    enSlug: "classroom-helper-picker",
    name: "Klassendienste-Auswahl",
    tagline: "Weise Klassendienste wie Tafeldienst oder Ordnungsdienst zufällig zu.",
    category: "Unterricht & Schule",
    icon: "Sparkles",
    keywords: ["klassendienste auswahl", "tafeldienst generator", "schulaufgaben verteilen"],
  },
  {
    slug: "buchstaben-zufallsgenerator",
    enSlug: "random-letter-picker",
    name: "Buchstaben-Zufallsgenerator",
    tagline: "Ziehe zufällige Buchstaben aus dem Alphabet A–Z, Vokale oder Konsonanten.",
    category: "Zufall & Auswahl",
    icon: "Type",
    keywords: ["buchstaben zufallsgenerator", "buchstabe ziehen online", "alphabet zufall"],
  },
  {
    slug: "wort-zufallsgenerator",
    enSlug: "random-word-picker",
    name: "Wort-Zufallsgenerator",
    tagline: "Wortdatenbanken für Rechtschreibung, Wortschatz und Sprachübungen.",
    category: "Zufall & Auswahl",
    icon: "BookA",
    keywords: ["wort zufallsgenerator", "zufallswörter deutsch", "wörter ziehen online"],
  },
  {
    slug: "entscheidungs-helfer",
    enSlug: "random-choice-picker",
    name: "Entscheidungs-Helfer Online",
    tagline: "Lass das Tool neutrale Entscheidungen für deine Klasse oder Gruppe treffen.",
    category: "Zufall & Auswahl",
    icon: "ListChecks",
    keywords: ["entscheidungs helfer", "zufallsentscheidung treffen", "auswahl treffen online"],
  },
  {
    slug: "ja-oder-nein",
    enSlug: "yes-or-no-picker",
    name: "Ja-oder-Nein-Generator",
    tagline: "Eine sofortige Antwort: Ja, Nein – oder Vielleicht.",
    category: "Zufall & Auswahl",
    icon: "CircleHelp",
    keywords: ["ja oder nein generator", "ja nein antwort online", "zufallsantwort ja nein"],
  },
  {
    slug: "farb-zufallsgenerator",
    enSlug: "random-color-picker",
    name: "Farb-Zufallsgenerator",
    tagline: "Wähle eine zufällige Farbe mit Namen und Hex-Code.",
    category: "Zufall & Auswahl",
    icon: "Palette",
    keywords: ["farb zufallsgenerator", "zufallsfarbe wählen", "hex farbe zufall"],
  },
  {
    slug: "fragen-zufallsgenerator",
    enSlug: "random-question-picker",
    name: "Fragen-Zufallsgenerator",
    tagline: "Diskussionsfragen und Impulsfragen auf Knopfdruck.",
    category: "Zufall & Auswahl",
    icon: "MessageCircleQuestion",
    keywords: ["fragen zufallsgenerator", "diskussionsfragen impuls", "fragen ziehen online"],
  },
  {
    slug: "gluecksrad",
    enSlug: "lucky-wheel",
    name: "Glücksrad für Verlosungen",
    tagline: "Ein bunter Gewinnrad-Klassiker für Unterricht und Events.",
    category: "Glücksräder",
    icon: "Gift",
    keywords: ["glücksrad verlosung", "online glücksrad", "gewinnrad online"],
  },
  {
    slug: "aktiviäten-rad",
    enSlug: "activity-wheel",
    name: "Unterrichtsaktivitäten-Rad",
    tagline: "Drehe für die nächste Unterrichtsübung oder Lernform.",
    category: "Glücksräder",
    icon: "Compass",
    keywords: ["aktivitäten rad", "unterrichtsmethoden rad", "lernformen glücksrad"],
  },
  {
    slug: "schueler-rad",
    enSlug: "student-wheel",
    name: "Schüler-Glücksrad",
    tagline: "Deine Klassenliste auf einem drehbaren Glücksrad.",
    category: "Glücksräder",
    icon: "UserRoundCheck",
    keywords: ["schüler rad", "schülerliste rad", "namensrad schule"],
  },
  {
    slug: "entscheidungsrad",
    enSlug: "decision-wheel",
    name: "Entscheidungsrad Drehen",
    tagline: "Ja, Nein, Vielleicht und beliebige eigene Optionen.",
    category: "Glücksräder",
    icon: "Split",
    keywords: ["entscheidungsrad drehen", "auswahlrad online", "entscheidung treffen rad"],
  },
  {
    slug: "reihenfolge-zufallsgenerator",
    enSlug: "random-line-order",
    name: "Reihenfolge-Zufallsgenerator",
    tagline: "Faire Aufstellung und Reihenfolge in einem Klick sortieren.",
    category: "Teams & Gruppen",
    icon: "ListOrdered",
    keywords: ["reihenfolge zufallsgenerator", "aufstellung schule zufall", "reihenfolge ziehen"],
  },
  {
    slug: "punkte-anzeige",
    enSlug: "classroom-scoreboard",
    name: "Klassenzimmer-Punkteanzeige",
    tagline: "Verfolge Team-Punkte live auf dem Beamer oder Screen.",
    category: "Unterricht & Schule",
    icon: "Trophy",
    featured: true,
    keywords: ["punkte anzeige lehrer", "klassenzimmer scoreboard", "teampunkte zählen beamer"],
  },
  {
    slug: "klassendienste-generator",
    enSlug: "classroom-job-picker",
    name: "Klassendienste-Generator",
    tagline: "Weise alle Klassendienste in einer einzigen Ziehung zu.",
    category: "Unterricht & Schule",
    icon: "ClipboardList",
    keywords: ["klassendienste generator", "schuldienste verteilen", "dienste klassenzimmer"],
  },
  {
    slug: "unterrichts-aktivitaeten",
    enSlug: "activity-picker",
    name: "Unterrichtsaktivitäten-Auswahl",
    tagline: "Ideen für Aufwärmübungen, Gruppenarbeit und Stundenabschluss.",
    category: "Unterricht & Schule",
    icon: "Lightbulb",
    keywords: ["unterrichtsaktivitäten auswahl", "stundeneinstieg ideen", "unterrichtsmethoden zufall"],
  },
  {
    slug: "bewegungs-pausen",
    enSlug: "brain-break-picker",
    name: "Bewegungspausen & Brain Breaks",
    tagline: "Schnelle Bewegungsimpulse und Entspannungsübungen für Schüler.",
    category: "Unterricht & Schule",
    icon: "Wind",
    keywords: ["bewegungspausen schule", "brain breaks deutsch", "auflockerung unterricht"],
  },
  {
    slug: "pantomime-generator",
    enSlug: "charades-generator",
    name: "Pantomime-Wörter-Generator",
    tagline: "Tiere, Berufe, Filme und Handlungen zum Darstellen.",
    category: "Spiele & Spaß",
    icon: "Drama",
    featured: true,
    keywords: ["pantomime generator", "scharade begriffe", "pantomime wörter deutsch"],
  },
  {
    slug: "montagsmaler-generator",
    enSlug: "pictionary-word-generator",
    name: "Montagsmaler / Begriffe-Generator",
    tagline: "Einfache bis schwere Begriffe zum Zeichnen und Erraten.",
    category: "Spiele & Spaß",
    icon: "Brush",
    keywords: ["montagsmaler generator", "pictionary wörter deutsch", "zeichenwörter generator"],
  },
  {
    slug: "wuerdest-du-eher",
    enSlug: "would-you-rather-generator",
    name: "Würdest du eher...? Generator",
    tagline: "Lustige Entscheidungsfragen zum Kennenlernen und Diskutieren.",
    category: "Spiele & Spaß",
    icon: "Scale",
    keywords: ["würdest du eher fragen", "würdest du eher generator", "dilemma fragen spiel"],
  },
  {
    slug: "quizfragen-generator",
    enSlug: "trivia-question-generator",
    name: "Quizfragen-Generator",
    tagline: "Fragen aus Naturwissenschaft, Geografie, Geschichte und Allgemeinwissen.",
    category: "Spiele & Spaß",
    icon: "Brain",
    keywords: ["quizfragen generator", "trivia deutsch", "allgemeinwissen fragen ziehen"],
  },
  {
    slug: "challenge-generator",
    enSlug: "random-challenge-generator",
    name: "Zufallschallenges-Generator",
    tagline: "Lustige und sichere Minichallenges für das Klassenzimmer.",
    category: "Spiele & Spaß",
    icon: "Flame",
    keywords: ["challenge generator", "minichallenges schule", "lustige aufgaben zufall"],
  },
];

export const getDeToolBySlug = (slug: string): DeToolMeta | undefined =>
  DE_TOOLS.find((t) => t.slug === slug || t.enSlug === slug);

export const getEnSlugForDeSlug = (deSlug: string): string => {
  const found = DE_TOOLS.find((t) => t.slug === deSlug || t.enSlug === deSlug);
  return found ? found.enSlug : deSlug;
};

export const getDeSlugForEnSlug = (enSlug: string): string => {
  const found = DE_TOOLS.find((t) => t.enSlug === enSlug || t.slug === enSlug);
  return found ? found.slug : enSlug;
};

export const relatedDeTools = (slug: string, count = 4): DeToolMeta[] => {
  const current = getDeToolBySlug(slug);
  const sameCategory = DE_TOOLS.filter((t) => t.slug !== current?.slug && t.category === current?.category);
  const others = DE_TOOLS.filter((t) => t.slug !== current?.slug && t.category !== current?.category);
  return [...sameCategory, ...others].slice(0, count);
};
